const FromArr = [
  {
    title: "",
    modelvalue: "",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "请输入内容",
    width: 234,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
    X: false,
   
    options: [
      {
        value: '{"hpid":31416}',
        lable: "应晓云[ad4001]",
      },
      {
        value: '{"hpid":31417}',
        lable: "经销商[3]",
      },
    ],
  },
  {
    title: "",
    inputtype: "date",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
    width: 234,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
];
export default FromArr;
